import React, { useState } from 'react';
import styled, { DefaultTheme, withTheme } from 'styled-components';
import { WebhooksSearchTabType as WebhooksTabType } from '../../../../types/webhooks/WebhooksTabType';
import Spinner from '../../../atoms/Spinner/Spinner';
import { Webhook } from '../../../../types/webhooks/Webhook';
import ButtonTab from '../../../atoms/Tabs/ButtonTab';
import { FailedWebhook } from '../../../../types/webhooks/FailedWebhook';
import { ResponseData } from '../../../../types/response/ResponseData';
import WebhooksSearchResults from './WebhooksSearchResults';
import FailedWebhooksSearchResults from './FailedWebhooksSearchResults';
import { BulkFailedWebhookActions } from './BulkFailedWebhookActions';
import { useWebhooksStore } from '../../../../store/admin/webhooks/webhooksStore';

interface SearchResultsProps {
    searchResults: ResponseData<Webhook[]>;
    searchFailedWebhooksResults: ResponseData<FailedWebhook[]>;
    theme: DefaultTheme;
    toggleCreate: () => void;
}

const WebhooksSearchResultsMain: React.FC<SearchResultsProps> = ({
    searchResults,
    searchFailedWebhooksResults,
    theme,
    toggleCreate,
}: SearchResultsProps) => {
    const { isSearching, isSearchingFailedWebhooks, moreFailedWebhooksResultsAvailable } =
        useWebhooksStore();

    const [tab, setTab] = useState<string>(WebhooksTabType.Webhooks);
    const webhooks = searchResults || [];
    const failedWebhooks = searchFailedWebhooksResults || [];
    const nrOfFailedWebhooks = () => {
        let nr = (failedWebhooks.data ? failedWebhooks.data.length : 0).toString();
        moreFailedWebhooksResultsAvailable && (nr += '+');
        return nr;
    };

    return (
        <>
            <ButtonTabsActions>
                <ButtonTabs>
                    <ButtonTab
                        large
                        tabKey={WebhooksTabType.Webhooks}
                        text={'Webhooks'}
                        setTab={setTab}
                        currentTab={tab}
                        subLabel={(webhooks.data ? webhooks.data.length : 0).toString()}
                    />
                    <ButtonTab
                        large
                        tabKey={WebhooksTabType.FailedWebhooks}
                        text={'Failed webhooks'}
                        setTab={setTab}
                        currentTab={tab}
                        subLabel={nrOfFailedWebhooks()}
                    />
                </ButtonTabs>

                {tab === WebhooksTabType.FailedWebhooks && <BulkFailedWebhookActions />}
            </ButtonTabsActions>
            {tab === WebhooksTabType.Webhooks ? (
                isSearching || !webhooks ? (
                    <Spinner loading={isSearching} />
                ) : (
                    <WebhooksSearchResults
                        searchResults={searchResults}
                        toggleCreate={toggleCreate}
                    />
                )
            ) : isSearchingFailedWebhooks || !failedWebhooks ? (
                <Spinner loading={isSearchingFailedWebhooks} />
            ) : (
                <FailedWebhooksSearchResults searchResults={searchFailedWebhooksResults} />
            )}
        </>
    );
};

const ButtonTabsActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const ButtonTabs = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 2rem;
    width: fit-content;
    border-radius: 0.5rem;
    background: ${props => props.theme.colors.medium};
`;

export default withTheme(WebhooksSearchResultsMain) as React.ComponentType<
    Omit<SearchResultsProps, 'theme'>
>;
